<script setup lang="ts">
import { type IProduct } from "~/types";
const props = defineProps({
  product: {
    type: Object as () => IProduct,
    required: true,
  },
  min: {
    type: Number,
    default: 1,
  },
  max: {
    type: Number,
    default: 10,
  },
});

const isShowPrompt = ref(false);

const prompt = computed(() => {
  if (props.max == -1) {
    return `Товар доступен в количестве 1 штуки`;
  }
  return `Товар доступен в количестве ${props.max} штук`;
});

const {
  productTotal,
  addProductToCart,
  removeProductFromCart,
} = useCart(props.product);


function decrement() {
  if (productTotal.value <= props.min) {
    return;
  }
  removeProductFromCart(1);
}

function increment() {
  if (productTotal.value >= props.max) {
    isShowPrompt.value = true;
    setTimeout(() => (isShowPrompt.value = false), 2000);
    return;
  }
  addProductToCart();
}
</script>
<template>
  <div class="relative">
    <div class="flex flex-row space-x-2 sm:space-x-4 h-9">
      <button @click="decrement" class="cursor-pointer">
        <p-icon-minus class="w-4 sm:w-6" />
      </button>
      <span
        class="flex items-center justify-center h-8 w-8 text-lg font-semibold rounded-md card_shadow"
        >{{ productTotal }}</span
      >
      <button @click="increment" class="cursor-pointer">
        <p-icon-plus class="w-4 sm:w-6" />
      </button>
    </div>
    <div
      v-if="isShowPrompt"
      style="z-index: 20"
      class="absolute inline min-w-max top-10 -right-6 px-4 py-2 bg-black opacity-80 text-white text-sm sm:text-base rounded-lg"
    >
      {{ prompt }}
    </div>
  </div>
</template>

<style scoped>
@media (min-width: 641px) {
  .card_shadow {
    box-shadow: 0px 4px 20px 0px #48507029;
  }
}
</style>
